/** Geometry shared by the live mark and exported installation artwork. */
export const BRAND_MARK = {
  viewBox: "0 0 100 100",
  outerRadius: 42,
  innerRadius: 28,
  coreRadius: 12,
  ringWidth: 9,
  sweepPath: "M50 50 L50 2 A48 48 0 0 1 91.5 26 Z",
  blipY: 6,
  blipRadius: 4,
};

export function brandMarkSvg(ink: string, accent: string) {
  const m = BRAND_MARK;
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${m.viewBox}" width="1024" height="1024"><circle cx="50" cy="50" r="${m.outerRadius}" fill="none" stroke="${ink}" stroke-width="${m.ringWidth}" opacity=".22"/><circle cx="50" cy="50" r="${m.innerRadius}" fill="none" stroke="${accent}" stroke-width="${m.ringWidth}" opacity=".85"/><path d="${m.sweepPath}" fill="${ink}" opacity=".16"/><circle cx="50" cy="${m.blipY}" r="${m.blipRadius}" fill="${accent}"/><circle cx="50" cy="50" r="${m.coreRadius}" fill="${ink}"/></svg>`;
}